import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import MainHeaderNoAuth from '@components/organisms/MainHeaderNoAuth';
import { useInformes } from '@hooks';
import { DataGrid } from '@components/atoms';
import { useTheme } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getDate } from '@helpers/utils';

const QrValidationPage = () => {
  const { codigo } = useParams();
  const location = useLocation();
  const {
    isInformeLoading, getFiles, getFilesCert, getInformeNoAuth,
  } = useInformes();
  const [informes, setInformes] = useState([]);
  const [dataSelected, setDataSelected] = useState([]);
  const theme = useTheme();
  const onlyxsSize = useMediaQuery(theme.breakpoints.only('xs'));

  const columnsSm = [
    {
      field: 'analisis',
      headerAlign: 'center',
      headerName: 'Ingreso', // texts.columns.number,
      flex: 1,
      align: 'center',
      valueGetter: (values) => values.row.data.analisis.number,
    },
    {
      field: 'file',
      headerAlign: 'center',
      headerName: 'Informe', // texts.columns.createdAt,
      align: 'center',
      flex: 1,
      valueFormatter: (values) => values.row.name,
    },
    {
      field: 'download',
      headerAlign: 'center',
      headerName: '⬇️', // texts.columns.createdAt,
      align: 'center',
      // valueFormatter: (values) => getDate(values.row.data.createdAt),
      renderCell: (value) => (
        <IconButton onClick={() => getURLPDF(value)}>
          {' '}
          <GetAppIcon />
          {' '}
        </IconButton>
      ),
    },
  ];

  const columns = [
    {
      field: 'contact',
      headerName: 'Cliente', // texts.columns.customer,
      flex: 0.5,
      valueGetter: (values) => values.row.data.contact.customer.name,
    },
    {
      field: 'analisis',
      headerAlign: 'center',
      headerName: 'Ingreso', // texts.columns.number,
      align: 'center',
      flex: 0.4,
      valueGetter: (values) => values.row.data.analisis.number,
    },
    {
      field: 'createdAt',
      headerAlign: 'center',
      headerName: 'Creado', // texts.columns.createdAt,
      align: 'center',
      flex: 0.6,
      type: 'date',
      valueFormatter: (values) => getDate(values.row.data.createdAt),
    },
    {
      field: 'file',
      headerAlign: 'center',
      headerName: 'Informe', // texts.columns.createdAt,
      align: 'center',
      flex: 0.6,
      valueFormatter: (values) => values.row.name,
    },
    {
      field: 'download',
      headerAlign: 'center',
      headerName: 'Descarga', // texts.columns.createdAt,
      align: 'center',
      flex: 0.6,
      // valueFormatter: (values) => getDate(values.row.data.createdAt),
      renderCell: (value) => (
        <IconButton onClick={() => getURLPDF(value)}>
          {' '}
          <GetAppIcon />
          {' '}
        </IconButton>
      ),
    },
  ];

  const downloadFiles = async (filesPDF) => {
    filesPDF.map(async (file) => {
      const fileURL = await getFilesCert({ customerId: file.data.contact.customer.id, facturacionId: file.data.id, name: file.name });
      if (fileURL) {
        const t = await fetch(fileURL);
        const b = await t.blob();
        const blobURL = URL.createObjectURL(b);
        const fileLink = document.createElement('a');
        fileLink.href = blobURL;

        // it forces the name of the downloaded file
        fileLink.download = file.name;

        // triggers the click event
        fileLink.click();

        // window.open(blobURL);
      }
      return fileURL;
    });
  };

  const getFilePDF = async (customerId, facturacionId) => {
    try {
      const doc = await getFiles({ customerId, facturacionId });
      return doc;
    } catch (error) {
      return [];
    }
  };

  const getURLPDF = async (value) => {
    const fileURL = await getFilesCert({ customerId: value.row.data.contact.customer.id, facturacionId: value.row.data.id, name: value.row.name });
    if (fileURL) {
      const t = await fetch(fileURL);
      const b = await t.blob();
      const blobURL = URL.createObjectURL(b);
      const fileLink = document.createElement('a');
      fileLink.href = blobURL;

      // it forces the name of the downloaded file
      fileLink.download = value.row.name;

      // triggers the click event
      fileLink.click();

      // window.open(blobURL);
    }
    return fileURL;
  };

  useEffect(async () => {
    const codeFromUrl = (codigo || new URLSearchParams(location.search).get('codigo') || '').trim();
    const result = await getInformeNoAuth(codeFromUrl);
    if (result) {
      const files = await getFilePDF(result.contact.customer.id, result.id);
      if (files) setInformes(files.map((_files) => ({ ..._files, data: result })));
    }
  }, [codigo, location.search]);

  const statusText = informes.length > 0 ? 'Válido' : 'No válido';
  let statusMessage = 'No se recibió ningún código en la URL.';

  if (informes.length > 0) {
    statusMessage = `El código ${codigo} cumple con el formato esperado.`;
  } else if (codigo && codigo.trim() !== '') {
    statusMessage = `El código ${codigo} no es válido.`;
  }

  const getSelectedData = (rowIds) => {
    const selectedData = informes.filter((row) => rowIds.selectionModel.includes(row.id));
    setDataSelected(selectedData);
  };

  return (
    <>
      <MainHeaderNoAuth />
      <Grid container justifyContent="center" spacing={2} style={{ padding: 80 }}>
        <Grid item sm={12}>
          {isInformeLoading && <LinearProgress />}
          <Typography variant="h5" gutterBottom>
            Validación de código
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Esta página validará codigo QR y determina si es informe es válido o no.
          </Typography>
        </Grid>
        {!isInformeLoading && (
          <>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                <Typography variant="subtitle1" style={{ paddingRight: 20 }}>
                  Código recibido:
                  {' '}
                  <strong>{codigo || 'No ingresado'}</strong>
                </Typography>
                <Chip
                  label={statusText}
                  color={informes.length > 0 ? 'primary' : 'secondary'}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {statusMessage}
              </Typography>
            </Grid>
            { !isInformeLoading && informes.length !== 0
                && (
                  <Grid item sm={12} style={{ width: '100%' }}>
                    <DataGrid
                      checkboxSelection
                      columns={onlyxsSize ? columnsSm : columns}
                      rows={informes}
                      onSelectionModelChange={(rowId) => getSelectedData(rowId)}
                    />
                  </Grid>
                )}
            <Grid item xs={12}>
              <Box display="flex" gap={3} flexWrap="wrap" mt={1}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => downloadFiles(dataSelected)}
                  disabled={!dataSelected || dataSelected.length === 0}
                >
                  Descargar reporte
                </Button>
                <Button component={Link} to="/n/validation" variant="outlined" color="primary">
                  Volver a validación
                </Button>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default QrValidationPage;
